import { render, staticRenderFns } from "./SharingEntryInherited.vue?vue&type=template&id=2bbe78b4&scoped=true&"
import script from "./SharingEntryInherited.vue?vue&type=script&lang=js&"
export * from "./SharingEntryInherited.vue?vue&type=script&lang=js&"
import style0 from "./SharingEntryInherited.vue?vue&type=style&index=0&id=2bbe78b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbe78b4",
  null
  
)

export default component.exports